import { Container } from '@material-ui/core';
import React, { useContext } from 'react';
import codings from '../../assets/lottie/coding.json';
import { ThemeContext } from '../../contexts/ThemeContext';
import { aboutData } from '../../data/aboutData';
import AnimationLottie from '../Animation';
import './About.css';
import Typed from "react-typed";
import Card from "react-bootstrap/Card";



function About() {

    const { theme } = useContext(ThemeContext);
    return (
        <div style={{ backgroundColor: theme.secondary }}>
            <Container className="about" id="about">
                <div className="line-styling">
                    <div className="style-circle" style={{ backgroundColor: theme.primary }}></div>
                    <div className="style-circle" style={{ backgroundColor: theme.primary }}></div>
                    <div className="style-line" style={{ backgroundColor: theme.primary }}></div>
                </div>
                <div className="about-body">
                    <div className="about-description">
                        <h2 style={{ color: theme.primary }}>{aboutData.title}</h2>
                        <Card.Text
              style={{
                textAlign: "left",
                fontFamily: "monospace",
                fontSize: "30px",
                color: "#2d4b79" ,
                padding:"10px",
               letterSpacing: "1px",
              
              }}
            >
              {" "}
              <Typed
                strings={[
                  "Nameste! <br/>I'm Kanav .....!<br/><br/>#Human..... since 1999<br/>$ Engineer....... since @2k16<br/>#Programmer..... @since 2018<br/>Be a terminal,Able to do anything but under the  limits..<br/>Look around to know more....... "  ,
                ]}
                typeSpeed={100}
                smartBackspace
              />
              
            </Card.Text>
                    </div>
                    <div className="about-animation">
                        <AnimationLottie animationPath={codings} />
                    </div>
                </div>
            </Container>
        </div>
    )
}

export default About
